import React, { useState, useEffect } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Table, Whisper, Tooltip } from 'rsuite';
import LegacyPlusIcon from "@rsuite/icons/legacy/Plus";
import Swal from 'sweetalert2';
import GenericBadge from '../../../Shared/Badge/GenericBadge';
import Information from '../../../Shared/Card/Information';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import AddNewSupervisingProfessionalModal from './AddNewSupervisingProfessionalModal'
import { GetSupervisingProfessionalFirmInstructions } from '../../../Shared/InformationContent/GeneralInformation';
import supervisingProfessionalService from '../../../../services/supervisingProfessional.service';
import applicationService from '../../../../services/Public/Application/application.service';
import LegacySendIcon from "@rsuite/icons/legacy/Send";
import LegacyFileTextIcon from "@rsuite/icons/legacy/FileText";
import ReloadIcon from '@rsuite/icons/Reload';
import ExternalFormModal from '../../../Shared/Modal/ExternalFormModal';
import axios from "axios";
import authHeader from "../../../../services/authheader";
import { useSelector } from 'react-redux';

function SupervisingProfessionalPage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [showAddNewButton, setShowAddNewButton] = useState(false);
    const [supervisingProfessionals, setSupervisingProfessionals] = useState([]);
    const [verifierModalShow, setVerifierModalShow] = useState(false);
    const [currentAttestationId, setCurrentAttestationId] = useState();
    const [individualAttestationFileName, setIndividualAttestationFileName] = useState();
    const firmName = useSelector(x => x.userInfo.FirmName);

    const openModal = (values) => {
        setModalShow(true);
    }
    useEffect(() => {
        reloadPageGrids();
    }, [])

    const reloadPageGrids = () => {
        setHasLoaded(false);
        refreshGrid();
        reloadAttestationGrid();
        setHasLoaded(true)
    }
    const refreshGrid = () => {
        applicationService.getFirmPendingApplications().then((response) => {
            if (response.data?.creds.length > 0 || response.data?.apps.length > 0) {
                setShowAddNewButton(true);
            }
            supervisingProfessionalService.getFirmSupervisingProfessional().then((data) => {
                setSupervisingProfessionals(data.data);
            })
        })
    }
    const inactivateSupervisingProfessional = (values) => {
        Swal.fire({
            title: 'Are you sure?',
            html: "By choosing to inactivate this supervising professional, this record <b>and</b> its associated attestation form will be removed from your supervising professional locker. Would you like to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                setHasLoaded(false)
                supervisingProfessionalService.inactivateSupervisingProfessional(values.relationshipId, values.supervisingProfessionalId)
                    .then(() => { reloadPageGrids(); })
                    .catch((error) => { if (error?.response?.data) { Swal.fire("Error!", error?.response?.data, 'error') } })
                    .finally(() => setHasLoaded(true));
                // Some service that removes it + refresh when it's good
            }
        })
    }
    const changeOwnership = (values) => {
        var text = values.isOwner ? "This will change the supervising professional to an employee of the firm." : "This will change the supervising professional to an owner of the firm.";
        console.log(values);
        Swal.fire({
            title: 'Are you sure?',
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                setHasLoaded(false)
                supervisingProfessionalService.changeSupervisingProfessionalOwnership(values.relationshipId, values.supervisingProfessionalId, values.firmEntityId)
                    .then(() => {
                        reloadPageGrids();
                        setHasLoaded(true);
                        Swal.fire({
                            title: 'Saved',
                            text: `An email notification was sent to ${values.professionalEmailAddress} to complete and submit an online Supervising Professional (SP) Attestation Form. This form must be completed and submitted before your SP ownership status can be changed. Once the SP Attestation Form has been submitted, your ownership status will update to the new status selected.`,
                            icon: 'success',
                            //confirmButtonColor: '#2976a3',
                            confirmButtonText: 'I have read and understood the message',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: false
                        })
                    })
                    .catch((error) => { if (error?.response?.data) { Swal.fire("Error!", error?.response?.data, 'error') } })
                    .finally(() => setHasLoaded(true));
            }
        })
    }
    const [supervisingProfessionalAttestationsHasLoaded, setSupervisingProfessionalAttestationsHasLoaded] = useState(false);
    const [supervisingProfessionalAttestations, setSupervisingProfessionalAttestations] = useState([]);

    const reloadAttestationGrid = () => {
        setSupervisingProfessionalAttestationsHasLoaded(false);
        supervisingProfessionalService.getSupervisingProfessionalAttestations(0, "ALL").then((result) => {
            setSupervisingProfessionalAttestations(result.data)
        }).then(() => {
            setSupervisingProfessionalAttestationsHasLoaded(true)
        });
    }

    const downloadAttestations = () => {
        if (!supervisingProfessionalAttestations.some(x => x.statusId === 4 || x.statusId === 5)) {
            Swal.fire({
                icon: 'error',
                text: "There are currently no attestation forms to download. Refer to Supervising Professional Attestations instructions above for submitting online attestations forms",
                confirmButtonText: "I understand"
            });
            return;
        }
        var urlProps = {
            url: process.env.REACT_APP_APIURL + "/Reports/GetAllSpAttestationForms",
            name: `Supervising Professional Attestations for ${firmName} ${new Date().toISOString().split('T')[0]}.pdf`
        };
        Swal.fire({
            title: 'Generating PDF',
            didOpen: () => {
                Swal.showLoading();
                axios.post(urlProps.url, null, { headers: authHeader(), responseType: 'arraybuffer' }).then((response) => {
                    var name = new String(response.headers['content-disposition']);
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', urlProps.name);
                    document.body.appendChild(link);
                    Swal.close()
                    link.click();
                    link.remove();
                });
            },
            allowOutsideClick: false
        })
    }

    return (
        <div>
            {verifierModalShow &&
                <ExternalFormModal show={verifierModalShow} onHide={() => setVerifierModalShow(false)} id={currentAttestationId} type={"applicationSpAttestation"} fileName={individualAttestationFileName} />
            }
            <Container fluid>
                <AddNewSupervisingProfessionalModal show={modalShow} onHide={() => setModalShow(false)} updateGrid={reloadPageGrids} />
                <h4 className="mb-3">Supervising Professional</h4>
                <Information content={GetSupervisingProfessionalFirmInstructions()} />
                <br />
                <Card>
                    <Card.Header>
                        <Row>
                            <Col>
                                <h6>Supervising Professional</h6>
                            </Col>
                            {showAddNewButton &&
                                <Col>
                                    <Button className="float-end" onClick={openModal}>
                                        <LegacyPlusIcon /> Add New</Button>
                                </Col>
                            }
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        {hasLoaded ?
                            <>
                                <Table wordWrap autoHeight data={supervisingProfessionals}>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            Name
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.professionalFormattedName)}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            License #
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.professionalFormattedLicenseNumber)}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={2}>
                                        <Table.HeaderCell>
                                            SP Employee/Owner Status (click to update)
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {
                                                rowData => (
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <div>
                                                            <b>Employee</b>
                                                        </div>
                                                        &nbsp;
                                                        <label className="switch" aria-label="Employee/Owner Toggle">
                                                            {["Approved", "Pending", "Active"].includes(rowData.codeVerificationStatus?.verificationStatus) ?
                                                                <input checked={rowData.isOwner} onChange={() => { changeOwnership(rowData) }} type="checkbox" />
                                                                :
                                                                <input checked={rowData.isOwner} onChange={() => { changeOwnership(rowData) }} type="checkbox" disabled />
                                                            }
                                                            <span className="slider round"></span>
                                                        </label>
                                                        &nbsp;
                                                        <div>
                                                            <b>Owner</b>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            Sent Date
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.sentDate ? new Date(rowData.sentDate).toLocaleDateString() : '')}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            Response Date
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.responseDate ? new Date(rowData.responseDate).toLocaleDateString() : '')}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                            Verification Status
                                        </Table.HeaderCell>
                                        <Table.Cell>{rowData => (rowData.codeVerificationStatus?.verificationStatus ? <GenericBadge status={rowData.codeVerificationStatus.verificationStatus.toUpperCase()} /> : '')}</Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={1}>
                                        <Table.HeaderCell>
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (
                                                <>
                                                    <Button className="ms-1" variant="danger" onClick={() => inactivateSupervisingProfessional(rowData)}>Inactivate</Button>
                                                </>
                                            )}
                                        </Table.Cell>
                                    </Table.Column>
                                </Table>
                            </> : <LoadingSpinner />
                        }
                    </Card.Body>
                </Card>
                <br />
                <Card>
                    <Card.Header>
                        <Row>
                            <Col>
                                <h6>Supervising Professional Attestations</h6>
                            </Col>
                            <Col className="text-end">
                                <Button onClick={downloadAttestations}>Download All Attestations</Button>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                                <h4>SP Attestation Icon Legend</h4>
                                <br/>
                                <ul>
                                    <li>                
                                        <LegacySendIcon
                                        title="Send email for attestation"
                                        style={{ cursor: "pointer", fontSize: "2em" }}/> - Send email for attestation
                                    </li>
                                    <li>                
                                        <LegacyFileTextIcon
                                        title="View attestation response"
                                        style={{ cursor: "pointer", fontSize: "2em" }}/> - View attestation response
                                    </li>
                                    <li>                
                                        <ReloadIcon
                                        title="Send re-attestation email"
                                        style={{ cursor: "pointer", fontSize: "2em" }}/> - Send re-attestation email
                                    </li>
                                </ul>
                        {supervisingProfessionalAttestationsHasLoaded ?
                            <>
                                <Table wordWrap autoHeight data={supervisingProfessionalAttestations}>
                                    <Table.Column flexGrow={2}>
                                        <Table.HeaderCell>
                                            Name
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.name)}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={.5}>
                                        <Table.HeaderCell>
                                            License #
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.licenseNumber)}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={.5}>
                                        <Table.HeaderCell>
                                            Verification Status
                                        </Table.HeaderCell>
                                        <Table.Cell>{rowData => {
                                            var status = "";
                                            switch (rowData.statusId) {
                                                case 1:
                                                    status = "Pending";
                                                    break;
                                                case 4:
                                                    status = "Verified";
                                                    break;
                                                case 5:
                                                    status = "Expired";
                                                    break;
                                                default:
                                                    status = "Not Yet Sent";
                                                    break;
                                            }
                                            return (status ? <GenericBadge status={status.toUpperCase()} /> : '')
                                        }}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={.5}>
                                        <Table.HeaderCell>
                                            Valid Through
                                        </Table.HeaderCell>
                                        <Table.Cell>
                                            {rowData => (rowData.expirationDate ? new Date(rowData.expirationDate).toLocaleDateString() : '')}
                                        </Table.Cell>
                                    </Table.Column>
                                    <Table.Column flexGrow={.5}>
                                        <Table.HeaderCell>
                                        </Table.HeaderCell>
                                        <Table.Cell dataKey="professionalEntityId">
                                            {rowData => {
                                                const createSpAttestation = () => {

                                                    supervisingProfessionalService.createSpAttestation(rowData.licenseNumber).then((result) => {
                                                        if (result.data) {
                                                            reloadAttestationGrid()
                                                            Swal.fire("Success", `Email has been successfully sent to ${rowData.professionalEmailAddress}.`, "success");
                                                        }
                                                    }).catch((error) => {
                                                        Swal.fire("Error", error.response.data, "error")
                                                    });

                                                }
                                                const createSpReAttestation = () => {
                                                    Swal.fire({
                                                        title: 'Are you sure?',
                                                        text: "You are about to send a re-attestation form. This will invalidate the current attestation and require the Supervising Professional to attest again!",
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonColor: '#3085d6',
                                                        cancelButtonColor: '#d33',
                                                        confirmButtonText: 'Yes, send it!'
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            supervisingProfessionalService.createSpAttestation(rowData.licenseNumber, true).then((result) => {
                                                                if (result.data) {
                                                                    reloadAttestationGrid()
                                                                    Swal.fire("Success", `Email has been successfully sent to ${rowData.professionalEmailAddress}.`, "success")
                                                                }
                                                            }).catch((error) => {
                                                                Swal.fire("Error", error.response.data, "error")
                                                            });
                                                        }
                                                    })
                                                }

                                                const viewAttestation = () => {
                                                    setIndividualAttestationFileName(`${rowData.name} (${rowData.licenseNumber}) SP Attestation Form ${new Date().toISOString().split('T')[0]}`)
                                                    setVerifierModalShow(true);
                                                    setCurrentAttestationId(rowData.spattestationId);
                                                }


                                                if (rowData.statusId == 4) {
                                                    return (<>
                                                        <Whisper placement="top" trigger="hover" speaker={<Tooltip>
                                                            View attestation response.
                                                        </Tooltip>}>
                                                            <LegacyFileTextIcon
                                                                title="View attestation response"
                                                                onClick={viewAttestation}
                                                                style={{ cursor: "pointer", fontSize: "2em", marginRight: ".5em" }} />
                                                        </Whisper>

                                                        <Whisper placement="top" trigger="hover" speaker={<Tooltip>
                                                            Send re-attestation email.
                                                        </Tooltip>}>
                                                            <ReloadIcon
                                                                title="Send re-attestation email"
                                                                onClick={createSpReAttestation}
                                                                style={{ cursor: "pointer", fontSize: "2em" }}
                                                            />
                                                        </Whisper>

                                                    </>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <Whisper placement="top" trigger="hover" speaker={<Tooltip>
                                                            Send email for attestation.
                                                        </Tooltip>}>
                                                            <LegacySendIcon
                                                                title="Send email for attestation"
                                                                onClick={createSpAttestation}
                                                                style={{ cursor: "pointer", fontSize: "2em" }}
                                                            />
                                                        </Whisper>


                                                    );
                                                }
                                            }}
                                        </Table.Cell>
                                    </Table.Column>
                                </Table>



                            </> : <LoadingSpinner />
                        }
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}

export default SupervisingProfessionalPage